import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./Header.module.css";
import ico from "../Assets/techicon.png";
import { useNavigate } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import githubIco from "../Assets/externallink.png";
import { useState } from "react";

const Header = () => {
  let navigate = useNavigate();
  const [showUnderline, setShowUnderline] = useState(false);
  const [showUnderlineBlog, setShowUnderlineBlog] = useState(false);
  const [showUnderlineProject, setShowUnderlineProject] = useState(false);
  const [showUnderlineGithub, setShowUnderlineGitub] = useState(false);

  const showToggle = () => setShowUnderline((showUnderline) => true);
  const hideToggle = () => setShowUnderline((showUnderline) => false);

  const showToggleBlog = () =>
    setShowUnderlineBlog((showUnderlineBlog) => true);
  const hideToggleBlog = () =>
    setShowUnderlineBlog((showUnderlineBlog) => false);

  const showToggleProject = () =>
    setShowUnderlineProject((showUnderlineProject) => true);
  const hideToggleProject = () =>
    setShowUnderlineProject((showUnderlineProject) => false);

  const showToggleGithub = () =>
    setShowUnderlineGitub((showUnderlineGithub) => true);
  const hideToggleGithub = () =>
    setShowUnderlineGitub((showUnderlineGithub) => false);

  const routeChange = () => {
    let path = `/`;
    navigate(path);
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand fixed-top fixed-left ${styles.MainHeader}`}
        role="navigation"
      >
        <ul className={`nav navbar-nav navbar-left ${styles.menuwrap}`}>
          <li className={styles.AboutMe} onClick={routeChange}>
            <img
              src={ico}
              alt="Logo"
              className={styles.AboutMeIco}
              onClick={routeChange}
            />
            <div
              className={styles.Github}
              style={{ paddingLeft: 10, fontWeight: "bold" }}
            >
              <Link className="nav-link" to="/">
                <div className={styles.titleName}>Hrusikesh Swain</div>
              </Link>
            </div>
          </li>
          <li
            className={`${styles.InlineMargin} ${
              showUnderline ? styles.HoverMe : styles.InlineMargin
            }`}
            onMouseOver={showToggle}
            onMouseOut={hideToggle}
            onClick={showToggle}
          >
            <Link className={`nav-link ${styles.titleName}`} to="/me">
              About me
            </Link>
          </li>
          <li
            className={`${styles.InlineMargin} ${
              showUnderlineBlog ? styles.HoverPost : styles.InlineMargin
            }`}
            onMouseOver={showToggleBlog}
            onMouseOut={hideToggleBlog}
          >
            <Link className={`nav-link ${styles.titleName}`} to="/writings">
              Writing
            </Link>
          </li>
          <li
            className={`${styles.InlineMargin} ${
              showUnderlineProject ? styles.HoverProject : styles.InlineMargin
            }`}
            onMouseOver={showToggleProject}
            onMouseOut={hideToggleProject}
          >
            <Link className={`nav-link ${styles.titleName}`} to="/projects">
              Projects
            </Link>
          </li>
          <li
            className={`${styles.Github} ${styles.InlineMargin} ${
              showUnderlineGithub ? styles.HoverGithub : styles.InlineMargin
            }`}
            onMouseOver={showToggleGithub}
            onMouseOut={hideToggleGithub}
          >
            <a
              className={`nav-link ${styles.titleName}`}
              href="https://github.com/hrusikeshswain"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div>Github</div>
                <img src={githubIco} alt={""} className={styles.GithubIco} />
              </div>
            </a>
          </li>
        </ul>
      </nav>
      <Outlet />
    </>
  );
};

export default Header;
